import { sliderAnatomy as s } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers as c, cssVar as a, defineStyle as i } from "@chakra-ui/styled-system";
import { orient as l } from "@chakra-ui/theme-tools";
const { defineMultiStyleConfig: d, definePartsStyle: b } = c(s.keys), o = a("slider-thumb-size"), n = a("slider-track-size"), r = a("slider-bg"), f = i((e) => {
  const { orientation: t } = e;
  return {
    display: "inline-block",
    position: "relative",
    cursor: "pointer",
    _disabled: {
      opacity: 0.5,
      cursor: "default",
      pointerEvents: "none"
    },
    ...l({
      orientation: t,
      vertical: { h: "100%", minH: "240px" },
      horizontal: { w: "100%", verticalAlign: "middle" }
    })
  };
}), u = i((e) => ({
  ...l({
    orientation: e.orientation,
    horizontal: { h: n.reference },
    vertical: { w: n.reference }
  }),
  overflow: "hidden",
  borderRadius: "full",
  [r.variable]: "colors.gray.200",
  bg: r.reference
})), h = i((e) => {
  const { orientation: t } = e;
  return {
    ...l({
      orientation: t,
      vertical: {
        left: "50%",
        transform: "translateX(-50%)"
      },
      horizontal: {
        top: "50%",
        transform: "translateY(-50%)"
      }
    }),
    w: o.reference,
    h: o.reference,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    outline: 0,
    zIndex: 1,
    borderRadius: "full",
    bg: "white",
    boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06)",
    border: "1px solid",
    borderColor: "transparent",
    transitionProperty: "transform",
    transitionDuration: "normal",
    _hover: {
      bg: "gray.50"
    },
    _focusVisible: {
      bg: "white",
      boxShadow: "outline"
    }
  };
}), y = i((e) => ({
  width: "inherit",
  height: "inherit",
  [r.variable]: "colors.teal.500",
  bg: r.reference
})), m = b((e) => ({
  container: f(e),
  track: u(e),
  thumb: h(e),
  filledTrack: y(e)
})), p = {
  md: {
    container: {
      [o.variable]: "sizes.4",
      [n.variable]: "sizes.1"
    }
  }
}, z = d({
  baseStyle: m,
  sizes: p,
  defaultProps: {
    size: "md"
  }
});
export {
  z as default
};
